export const getFailureMessage = async (response, fallbackMessage) => {
  try {
    const payload = await response.json();
    return payload?.detail || payload?.message || fallbackMessage;
  } catch {
    return fallbackMessage;
  }
};

export const normalizeFailureMessage = (message) => {
  const text = (message || "").trim();
  if (text.includes("Each row must include veeva_crm_field and vault_crm_field")) {
    return "Unable to process file. Required columns are missing: veeva_crm_field and vault_crm_field.";
  }
  if (text.toLowerCase().includes("signal is aborted") || text.toLowerCase().includes("request timed out")) {
    return "The request timed out while generating content. Please retry; generation will continue from the next pending row.";
  }
  return text || "Request failed";
};
